const replacePlaceholders = (
  text,
  rowData = {},
  listDataIdMap = {},
  fieldSpecificMap = {},
  rowSuffix = '',
  fieldMetadata = {},
) => {
  if (typeof text !== 'string') {
    return text === null || text === undefined ? '' : text;
  }


  if (!text.includes('[[')) {
    return text;
  }

  // Match text wrapped in double square brackets, e.g., [[placeholder]]
  const placeholderRegex = /\[\[([^[\]]*)\]\]/g

  let rowDataKeysByField = null;

  const replacedText = text.replace(placeholderRegex, (match, placeholder) => {
    // Resolve the numeric field ID using the explicit map or parse if it's already a numeric field ID string
    let fieldId = fieldSpecificMap[placeholder] || (isNaN(placeholder) ? null : placeholder)

    // If no field ID mapping is found, try falling back to valuesObject or original match string
    if (!fieldId) {
      console.warn(`[Placeholder Error] Key "${placeholder}" NOT MAPPED to any field ID! Check backend mapping. Falling back to default.`);
      return match
    }

    // Determine field configuration to check if we should map lookup IDs to display labels
    const fMeta = fieldMetadata[fieldId] || fieldMetadata[String(fieldId)];
    const ds = fMeta?.data_structure;
    const isList = ds === 'list' || ds === 'list-multi';
    const isSubfield = fMeta?.is_subfield === true;

    // Prioritize key with current row suffix if provided
    let fieldKey = null
    if (rowSuffix) {
      const specificKey = `f_${fieldId}${rowSuffix}`
      if (rowData[specificKey] !== undefined) {
        fieldKey = specificKey
      }
    }

    if (!fieldKey) {
      // First, if there's a global key (standalone field stored without suffix), use it.
      const globalKey = `f_${fieldId}`
      if (rowData[globalKey] !== undefined) {
        fieldKey = globalKey
      }

      // Fallback to row index 1 if we're in a row context but the specific row suffix wasn't found,
      // provided this field is a standalone field (no other row indices exist for this field in rowData).
      // If there are multiple rows, we do not fallback to prevent repeating data across rows.
      if (!fieldKey && rowSuffix && !isSubfield) {
        if (!rowDataKeysByField) {
          rowDataKeysByField = new Map()
          Object.keys(rowData || {}).forEach((key) => {
            if (key.startsWith('f_')) {
              const parts = key.split('__')
              const fId = parts[0].split('_')[1]
              if (fId) {
                if (!rowDataKeysByField.has(fId)) {
                  rowDataKeysByField.set(fId, [])
                }
                rowDataKeysByField.get(fId).push(key)
              }
            }
          })
        }
        const fieldKeys = rowDataKeysByField.get(String(fieldId)) || []
        const hasMultipleRows = fieldKeys.some(k => k !== `f_${fieldId}__1`);
        if (!hasMultipleRows && rowData[`f_${fieldId}__1`] !== undefined) {
          fieldKey = `f_${fieldId}__1`;
        }
      }
    }

    // Broad matching: if we are not in a row context, search key matching pattern `f_<fieldId>` or `f_<fieldId>__<number>`
    if (!fieldKey && !rowSuffix) {
      if (!rowDataKeysByField) {
        rowDataKeysByField = new Map()
        Object.keys(rowData || {}).forEach((key) => {
          if (key.startsWith('f_')) {
            const parts = key.split('__')
            const fId = parts[0].split('_')[1]
            if (fId) {
              if (!rowDataKeysByField.has(fId)) {
                rowDataKeysByField.set(fId, [])
              }
              rowDataKeysByField.get(fId).push(key)
            }
          }
        })
      }
      const fieldKeys = rowDataKeysByField.get(String(fieldId)) || []
      if (fieldKeys.length > 0) {
        fieldKey = fieldKeys[0]
      }
    }

    // If key could not be located in current rowData context, warn and return original placeholder match
    if (!fieldKey) {
      console.warn(`[Placeholder Debug] "${placeholder}" -> ID ${fieldId}: NOT FOUND in context. Avail keys (up to 50):`, Object.keys(rowData).slice(0, 50));
      return match
    }

    const fieldValue = rowData[fieldKey]

    if (fieldValue !== -1 && fieldValue !== undefined && fieldValue !== null && fieldValue !== '') {
      const resolveDisplayValue = (val) => {
        // ONLY resolve if we explicitly know it's a list field.
        // Doing this prevents accidental matching (e.g., age value "30" matching a list option ID of 30).
        if (fMeta && !isList) {
          return val;
        }

        const fieldListId = fMeta?.list_id;

        // O(1) map lookup — key is list_data_id (data-entry) or id (preview), both equal the stored val
        const metadataItem = listDataIdMap[val]

        // Optional cross-check: ensure item belongs to the expected list
        if (metadataItem && fieldListId && metadataItem.list_id &&
            String(metadataItem.list_id) !== String(fieldListId)) {
          return val
        }

        return metadataItem?.list_data_value || metadataItem?.value || val
      }

      const result = Array.isArray(fieldValue) ? fieldValue.map(resolveDisplayValue).join(', ') : resolveDisplayValue(fieldValue)
      return result || match
    }

    return match
  })

  return replacedText
}

module.exports = { replacePlaceholders }
